const fanClubStoreInitialState = {
  username: '',
  performerFanClubInfo: {},
  successfullyJoined: false,
  isFan: false,
  waitingToJoinFanclub: false,
};

export default fanClubStoreInitialState;
